import React, {Component} from "react";
import {Field, reduxForm, change} from "redux-form/immutable";
import ActionButton from "../../../components/ActionButton";
import FormFieldsTable from "../../../components/forms/FormFieldsTable";
import TextInputField from "../../../components/forms/TextInputField";
import TextAreaInputField from "../../../components/forms/TextAreaInputField";
import FormError from "../../../components/forms/FormError";

function numerical(value) {
  let parsed = parseInt(value, 10);
  if (isNaN(parsed)) return value;
  return parsed;
}

class RegisterWaterPalletForm extends Component {

  handleLoadFromJson() {
    let json = prompt("Paste JSON here");
    if (json) {
      try {
        let parsed = JSON.parse(json);
        this.props.onJSON(parsed);
      } catch (err) {
        alert("Invalid JSON");
      }
    }
  }

  render() {
    let {errors, handleSubmit, submit, submitting} = this.props;
    let submitLabel = submitting ? "Standby..." : "Submit"; 
    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <FormFieldsTable>
            <Field 
              label="Pallet Id"
              name="palletId"
              component={TextInputField}
              showBlank={true}
              serverError={this.props.errors.palletId}
              />
            <Field 
              label="Inventory SKU"
              name="inventorySku"
              component={TextInputField}
              showBlank={true}
              serverError={this.props.errors.inventorySku}
              />
            <Field 
              label="Inventory Ids (comma separated)"
              name="inventoryIds"
              component={TextAreaInputField}
              serverError={this.props.errors.inventoryIds}
              />              
          </FormFieldsTable>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton label={submitLabel} onClick={submit} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
          <ActionButton label="Load from JSON" onClick={this.handleLoadFromJson.bind(this)} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "RegisterWaterPalletForm"
})(RegisterWaterPalletForm);

export default ReduxForm;